import * as React from "react";
import {authorize, Overlay} from "@athena-portal/components";
import {PluginTemplates} from "../../../../../utils/PluginTemplates";
import {MissedPaymentForm} from "./MissedPaymentForm";
import FalconHeader from "../../../../../components/navigation/FalconHeader";
import {Redirect} from "react-router-dom";
import {getSessionStorage} from "../../../../../CommonFunctions";
import {
    AnnualPolicyPremiumTypeEnum,
    FalconNavigatorHeader,
    ICustomerPortalService,
    ProductsEnum,
    Types
} from "@falcon/services";
import {lazyInject} from "@athena-portal/core";
import FalconFooter from "../../../../../components/navigation/FalconFooter";

interface IProps {
    match?: any
    location?: any
}

interface IState {
    premiumType?: string,
    dataLoaded: boolean
}

@authorize
export class MissedPaymentPage extends React.Component<IProps, IState> {
    @lazyInject(Types.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;

    private pluginTemplates = new PluginTemplates();
    private readonly paymentPaid: any;

    constructor(props: IProps) {
        super(props);
        this.paymentPaid = window.sessionStorage.getItem("paymentAmount");

        this.state = {
            dataLoaded: false
        };
    }

    public componentDidMount() {
        this.pluginTemplates.setPageTitle("Payment");

        this.customerPortalService.getPolicyPremiumTypeByPolicyNumber(this.props.match.params.policyNumber).subscribe((result: string) => {
            this.setState({
                premiumType: result,
                dataLoaded: true
            })
        });
    }

    public render() {
        const dataLoaded = this.state.dataLoaded;
        return (
            <React.Fragment>
                <Overlay show={!dataLoaded}/>
                <FalconHeader/>
                {dataLoaded && this.renderPageContents()}
                <FalconFooter/>
            </React.Fragment>
        );
    }

    private getRedirectUrl = (): string => {
        const product: string = this.props.location?.state?.product ?
            this.props.location?.state?.product : getSessionStorage("missedPaymentProduct");
        let redirectUrl: string;

        if (product === ProductsEnum.WOLF_MOTOR || product === ProductsEnum.HOME) {
            redirectUrl = this.state.premiumType === AnnualPolicyPremiumTypeEnum.MONTHLY
                ? `/dashboard/monthlyPaymentHistory/${this.props.match.params.policyNumber}`
                : `/dashboard/annualPaymentHistory/${this.props.match.params.policyNumber}`;
        } else {
            redirectUrl = "/dashboard/paymentHistory";
        }

        return redirectUrl;
    }

    private renderPageContents(): JSX.Element {
        if (this.paymentPaid) {
            return <Redirect to={this.getRedirectUrl()}/>
        } else {
            return (
                <div className="plugin">
                    <FalconNavigatorHeader back={this.getRedirectUrl()} title="Payment"/>
                    <MissedPaymentForm
                        verifyNewCardFailed={this.props.location?.state?.verifyCardFailed}
                        product={this.props.location?.state?.product ?
                            this.props.location?.state?.product : getSessionStorage("missedPaymentProduct")}
                        policyNumber={this.props.match.params.policyNumber}
                        invoiceId={this.props.match.params?.invoiceId}/>
                    {this.pluginTemplates.renderBackReloadLink("Back", false, this.getRedirectUrl())}
                </div>
            );
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/common/payments/missedPayment/MissedPaymentPage.tsx